
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/authLoggingContentPane';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.auth_logging_content_pane")
  },data:data},helper ? helper.call(depth0, "user_login_logout_activity_90fbbd9a", "User Login / Logout Activity", options) : helperMissing.call(depth0, "t", "user_login_logout_activity_90fbbd9a", "User Login / Logout Activity", options)))
    + "</h2>\n<p>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.auth_logging_content_pane")
  },data:data},helper ? helper.call(depth0, "to_view_all_login_logout_activities_of_a_canvas_us_f2953e60", "To view all login / logout activities of a Canvas user, select the user and date range for your search.", options) : helperMissing.call(depth0, "t", "to_view_all_login_logout_activities_of_a_canvas_us_f2953e60", "To view all login / logout activities of a Canvas user, select the user and date range for your search.", options)))
    + "\n</p>\n\n<form id=\"authLoggingSearchForm\" class='form-horizontal'></form>\n<hr aria-hidden=\"true\"/>\n\n<div id=\"authLoggingSearchResults\"></div>\n\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  